export const ENROLLED_OBJECT = 'ENROLLED_OBJECT';
export const COPY_ASSOCIATION = 'COPY_ASSOCIATION';